import React, { useState } from "react";
import {
  Layout,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  Input,
  Button,
} from "antd";
import {
  TwitterOutlined,
  LinkedinOutlined,
  GithubOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

const { Footer } = Layout;
const { Text, Link } = Typography;
const { Search } = Input;

// ... (Imports)
// ... (Imports)

// ... (Imports)

// ... (Imports)

const AppFooter = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    // Add your subscribe logic here
    console.log(`Subscribed with email: ${email}`);
    // You can make an API call or perform other actions here
    // For now, just log the email to the console
  };

  return (
    <Footer
      style={{ background: "#263238", color: "#eceff1", padding: "20px" }}
    >
      <Row gutter={[16, 16]} justify="space-around" align="middle">
        <Col xs={24} sm={12} md={8}>
          <div
            style={{
              textAlign: "center",
              borderRadius: "10px",
              padding: "20px",
              background: "#37474f",
              border: "1px solid #607d8b",
            }}
          >
            <Text strong style={{ fontSize: "1.5rem", color: "#eceff1" }}>
              Connect With Us
            </Text>
            <Divider style={{ borderColor: "#607d8b" }} />
            <Space size={16} direction="vertical">
              <Row align="middle" justify="center">
                <Link
                  href="mailto:contact@eljousour.com"
                  style={{ marginBottom: "8px", marginRight: "8px" }}
                >
                  <Button
                    style={{ background: "#263238", borderColor: "#607d8b" }}
                    size="large"
                    type="primary"
                    icon={<MailOutlined />}
                  >
                    contact@eljousour.com
                  </Button>
                </Link>
                <Link
                  href="mailto:contact@eljousour.com"
                  style={{ marginBottom: "8px" }}
                >
                  <Button size="large" icon={<WhatsAppOutlined />}>
                    What's UP
                  </Button>
                </Link>
              </Row>
              <Row justify="space-around">
                <Link
                  href="https://twitter.com/yourhandle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TwitterOutlined
                    style={{ fontSize: "1.5rem", color: "#eceff1" }}
                  />
                </Link>
                <Link
                  href="https://linkedin.com/yourprofile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedinOutlined
                    style={{ fontSize: "1.5rem", color: "#eceff1" }}
                  />
                </Link>
                <Link
                  href="https://github.com/yourusername"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GithubOutlined
                    style={{ fontSize: "1.5rem", color: "#eceff1" }}
                  />
                </Link>
              </Row>
            </Space>
          </div>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <div
            style={{
              textAlign: "center",
              borderRadius: "10px",
              padding: "20px",
              background: "#37474f",
              border: "1px solid #607d8b",
            }}
          >
            <Text strong style={{ fontSize: "1.5rem", color: "#eceff1" }}>
              Quick Links
            </Text>
            <Divider style={{ borderColor: "#607d8b" }} />
            <Space direction="vertical" size={8}>
              <Link href="/about" style={{ color: "#eceff1" }}>
                About Us
              </Link>
              <Link href="/services" style={{ color: "#eceff1" }}>
                Services
              </Link>
              <Link href="/contact" style={{ color: "#eceff1" }}>
                Contact Us
              </Link>
            </Space>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <div
            style={{
              textAlign: "center",
              borderRadius: "10px",
              padding: "20px",
              background: "#37474f",
              border: "1px solid #607d8b",
            }}
          >
            <Text strong style={{ fontSize: "1.5rem", color: "#eceff1" }}>
              Newsletter
            </Text>
            <Divider style={{ borderColor: "#607d8b" }} />
            <Text style={{ color: "#eceff1" }}>
              Subscribe to our newsletter for updates.
            </Text>
            <div style={{ height: "20px" }} />
            <Row justify="center">
              <Col>
                <Space>
                  <Search
                    placeholder="Enter your email"
                    value={email}
                    size="large"
                    onChange={(e) => setEmail(e.target.value)}
                    enterButton={
                      <Button
                        style={{
                          background: "#263238",
                          borderColor: "#607d8b",
                        }}
                        type="primary"
                        onClick={handleSubscribe}
                      >
                        Subscribe
                      </Button>
                    }
                    onSearch={handleSubscribe}
                  />
                </Space>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Divider style={{ borderColor: "#607d8b" }} />
      <Row justify="center">
        <Col>
          <p
            style={{
              color: "#eceff1",
              padding: "10px",
            }}
          >
            &copy; {currentYear} Eljousour. All rights reserved.
          </p>
        </Col>
      </Row>
    </Footer>
  );
};

export default AppFooter;
